export default class WalletTemplatePreviewModalController {

    constructor($uibModalInstance, $scope, $injector, templateModel) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.fileSaver = this.injector.get('FileSaver');

        this.templateModel = templateModel;
        this.loadingPreview = true;
        this.rsvpIdToPreview = null;
        this.previewData = null;
        this.walletSlide = 1;

        this.previewColors = {
            background: '',
            fore: '',
            label: ''
        }
    }

    handleRsvpSelect(rsvpId) {
        if (!_.isEqual(rsvpId, this.rsvpIdToPreview)) {
            this.rsvpIdToPreview = rsvpId;
            this._loadPreview();
        }
    }

    downloadPreview() {
        return this.api
            .post('wallets/templates/download-preview', {
                rsvp_id: this.rsvpIdToPreview,
                template: this.templateModel
            }, {
                responseType: "blob"
            })
            .then(({headers, data}) => {
                const blob = new Blob([data], {type: headers('content-type')});
                this.fileSaver.saveAs(
                    blob,
                    'preview.pkpass'
                );
            })
            .catch((e) => {
                this.alert.handle(e);
            })
    }

    dismiss() {
        this.uibModalInstance.close();
    }

    _loadPreview() {
        if(!this.rsvpIdToPreview) {
            return;
        }

        this.loadingPreview = true;
        return this.api
            .post('wallets/templates/render-preview', {
                rsvp_id: this.rsvpIdToPreview,
                template: this.templateModel
            })
            .then(({data}) => {
                this.previewData = data.data;
                this.loadingPreview = false;
                this.walletSlide = 1;

                _.map(this.previewColors, (val, key) => {
                    const apiColor = this.previewData.colors[`${key}_color`];

                    this.previewColors[key] = `rgb(${apiColor.red},${apiColor.green},${apiColor.blue})`;
                })
            })
            .catch((e) => {
                this.alert.handle(e);
            })
    }
}

WalletTemplatePreviewModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'templateModel'
]



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/controllers/modals/preview-modal.js